import { classNameType } from "@/types/generalTypes";
import React from "react";

function BasketIcon({ className }: classNameType) {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2522 9.25164H3.08082C2.87842 9.24991 2.67801 9.29163 2.4931 9.37397C2.3082 9.4563 2.14311 9.57734 2.00897 9.72891C1.87484 9.8805 1.77477 10.0591 1.71553 10.2526C1.65629 10.4462 1.63926 10.6502 1.66558 10.8509L2.6987 18.6346C2.74361 18.9772 2.91232 19.2917 3.17302 19.5184C3.43372 19.7453 3.7684 19.8688 4.11394 19.8659H17.1908C17.5363 19.8688 17.871 19.7453 18.1316 19.5184C18.3923 19.2917 18.561 18.9772 18.606 18.6346L19.6392 10.8509C19.6651 10.6525 19.6488 10.4509 19.5912 10.2594C19.5336 10.0678 19.4361 9.89065 19.305 9.73954C19.174 9.58842 19.0124 9.46681 18.8309 9.3827C18.6495 9.29861 18.4522 9.25393 18.2522 9.25164Z"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12842 12.7896V16.3276"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 12.7896V16.3276"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2046 12.7896V16.3276"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1765 2.93982C15.0243 3.08628 15.801 3.50562 16.3886 4.13405C16.9762 4.76248 17.3424 5.56562 17.4316 6.42131L17.7429 9.25178"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.59058 9.25168L3.90193 6.4212C3.99692 5.57058 4.36573 4.77388 4.95281 4.15106C5.5399 3.52824 6.31345 3.11305 7.15698 2.96802"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2046 3.23682C14.2046 3.46913 14.1589 3.69918 14.0699 3.9138C13.981 4.12844 13.8507 4.32346 13.6865 4.48772C13.5222 4.652 13.3272 4.7823 13.1125 4.87121C12.8979 4.96011 12.6679 5.00587 12.4356 5.00587H8.89747C8.42829 5.00587 7.97833 4.81948 7.64656 4.48772C7.3148 4.15596 7.12842 3.706 7.12842 3.23682C7.12842 2.76764 7.3148 2.31768 7.64656 1.98592C7.97833 1.65415 8.42829 1.46777 8.89747 1.46777H12.4356C12.9047 1.46777 13.3547 1.65415 13.6865 1.98592C14.0182 2.31768 14.2046 2.76764 14.2046 3.23682Z"
        stroke="#4A4A4A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BasketIcon;
